/*
 * Automatically generated by SVGR from assets/icons/*.svg.
 * Do not edit this file or add other components to this directory.
 */
import type { SVGProps } from 'react'
export function OffIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      fill='none'
      viewBox='0 0 16 16'
      {...props}
    >
      <mask
        id='off_svg__a'
        width={16}
        height={16}
        x={0}
        y={0}
        maskUnits='userSpaceOnUse'
        style={{
          maskType: 'alpha',
        }}
      >
        <path fill='#D9D9D9' d='M.421.5h15v15h-15z' />
      </mask>
      <g mask='url(#off_svg__a)'>
        <path
          fill='#9DA1A9'
          d='M12.78 14.64 11.36 13.22a6.4 6.4 0 0 1-1.633.765 6.1 6.1 0 0 1-1.805.266 6.1 6.1 0 0 1-2.437-.492 6.3 6.3 0 0 1-1.985-1.336 6.3 6.3 0 0 1-1.336-1.985A6.1 6.1 0 0 1 1.671 8q0-.938.266-1.805a6.4 6.4 0 0 1 .766-1.633L1.28 3.141l.89-.891 11.5 11.5zM7.922 13a4.96 4.96 0 0 0 2.532-.687L3.609 5.469A4.956 4.956 0 0 0 2.922 8q0 2.078 1.46 3.54Q5.843 13 7.922 13m5.219-1.562-.906-.907q.343-.594.515-1.226.172-.633.172-1.305 0-2.078-1.46-3.54Q9.998 3 7.92 3a4.96 4.96 0 0 0-2.531.688l-.906-.907a6.4 6.4 0 0 1 1.633-.765A6.1 6.1 0 0 1 7.92 1.75q1.297 0 2.438.492 1.14.492 1.984 1.336a6.3 6.3 0 0 1 1.336 1.985q.492 1.14.492 2.437 0 .938-.265 1.805a6.4 6.4 0 0 1-.766 1.633'
        />
      </g>
    </svg>
  )
}
